/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-9450cd75.js';
import '@carbon/icon-helpers';
import 'vue';

const OverflowMenuVertical16 = createSVGComponent('OverflowMenuVertical16', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 32 32",
  "fill": "currentColor",
  "width": 16,
  "height": 16
}, [{
  "elem": "circle",
  "attrs": {
    "cx": "16",
    "cy": "8",
    "r": "2"
  }
}, {
  "elem": "circle",
  "attrs": {
    "cx": "16",
    "cy": "16",
    "r": "2"
  }
}, {
  "elem": "circle",
  "attrs": {
    "cx": "16",
    "cy": "24",
    "r": "2"
  }
}]);

export { OverflowMenuVertical16 as default };
